export default {
  form: {
    bank_account_number: {
      label: 'Numer konta',
      placeholder: 'DE01101234567891234567',
    },
    bank_routing_number: {
      label: 'Numer rozliczeniowy',
      placeholder: '110000000',
    },
    bank_country: {
      label: 'Kraj',
      placeholder: 'Niemcy',
    },
    bank_statement_descriptor: {
      label: 'Opis na wyciągu',
      placeholder: 'Nazwa restauracji',
      tooltip: 'Ta nazwa będzie widoczna na wyciągach bankowych klientów',
    },
  },
  buttons: {
    next: 'Dalej',
    back: 'Wstecz',
    use_test_data: 'Użyj danych testowych',
  },
  test_data_hint: 'Testowe konto bankowe akceptowane przez {{gateways}}',
  read_only_warning:
    'Dane bankowe może zmieniać tylko nasz zespół. Aby je zaktualizować, skontaktuj się z pomocą techniczną.',
};
